import config from "../../app.json";
import axios from "axios";

import "./inviteteammember.scss";
import React, { useState, useEffect, useContext } from "react";
import FieldText from "../Fields/FieldText";
import { emailValidation } from "../../helper";
import ModalComponent from "../ModalComponent";
import AlertComponent from "../AlertComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faSquare } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../Reducers/Store";

import { Button } from "react-bootstrap";
import PlusIcon from "../../Assets/Images/plus.svg";

function InviteTeamMember(props) {
  const [state, dispatch] = useContext(Context);

  const [email, setEmail] = useState(null);
  const [userLimit, setUserLimit] = useState(0);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [allMembersOptions, setAllMembersOptions] = useState([]);
  const [qtyMembersOptions, setQtyMembersOptions] = useState([]);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (state?.isLogged) {
      dispatch({ type: "SET_LOADING", payload: true });

      axios
        .get(config.API_HM + "/profile")
        .then((result) => {
          if (result.data.subscription) {
            setUserLimit(result.data.subscription.usersLimit ?? 1);
          }
        })
        .catch((error) => {
          AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 2", { icon: `error` });
        })
        .finally(() => {
          dispatch({ type: "SET_LOADING", payload: false });
        });

      let filters = "offset=0&orderBy=name";
      axios
        .get(config.API_HM + "/subscriptions/members?" + filters)
        .then((result) => {
          if (result.data.total) {
            setAllMembersOptions(result.data.records);
            setQtyMembersOptions(result.data.total);
          }
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.Message, { icon: `error` });
        });
    }
  }, [state?.isLogged]);

  const checkDisabled = () => {
    const crossedLimit = qtyMembersOptions + selectedMembers.length >= userLimit;
    setDisabled(crossedLimit);
  };
  useEffect(() => {
    checkDisabled();
  }, [qtyMembersOptions]);

  const submit = async () => {
    if (!selectedMembers.length) {
      return AlertComponent("Error", "No users added.", { icon: `error` });
    }

    selectedMembers.map((x) => {
      const payload = {
        email: x,
      };

      axios
        .post(config.API_HM + "/subscriptions/invitations", payload)
        .then(() => {
          AlertComponent("Success", "All added members were successfully invited.");
          handleCancel();
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.message || error?.message, { icon: `error` });
        });
    });
  };

  useEffect(() => {
    checkDisabled();
  }, [selectedMembers]);

  const handleAddMember = () => {
    if (disabled) {
      return;
    }

    if (!email) {
      AlertComponent(`Error`, `Type a valid email.`, { icon: `error` });
      return false;
    }

    if (!emailValidation(email)) {
      AlertComponent(`Error`, `Email is not valid.`, { icon: `error` });
      return false;
    }

    if (selectedMembers.includes(email)) {
      AlertComponent(`Error`, `Email is already in the invitation list.`, { icon: `error` });
      return false;
    }

    const existingMail = allMembersOptions.filter((person) => {
      return person.email.toLowerCase().includes(email.toLowerCase());
    });

    if (existingMail.length) {
      AlertComponent(`Error`, `Email is already a member.`, { icon: `error` });
      return false;
    }
    setSelectedMembers((prevItems) => [...prevItems, email]);
    setEmail("");
  };

  const removeItemFromList = (index) => {
    const updatedPeople = [...selectedMembers];
    updatedPeople.splice(index, 1);
    setSelectedMembers(updatedPeople);
  };

  const handleCancel = () => {
    setEmail("");
    setSelectedMembers([]);
    props.closeAddNewMembers();
  };

  const content = (
    <div className="inviteteammember-container inviteteammember-component">
      <div className="inviteteammember-content">
        <div className="inviteteammember-row">
          <div className="inviteteammember-column">
            <h5>Invite team member</h5>
          </div>
        </div>
        <div className="inviteteammember-column newcharlist-panel">
          <div className="inviteteammember-row">
            <div>
              <div className="input-container">
                <div className="icon-container">
                  <FontAwesomeIcon style={{ color: "#000000", fontSize: "1.25em" }} icon={faEnvelope} />
                </div>
                <FieldText
                  type="text"
                  disabled={disabled}
                  onChange={(x) => setEmail(x.target.value)}
                  placeholder="Email"
                  value={email}
                  required={true}
                  inputClassName="select-container-mail"
                />
                {!disabled && (
                  <div className="select-container">
                    <span
                      style={{ cursor: disabled ? "no-drop" : "pointer", backgroundColor: "#0084ff", display: "flex", borderRadius: "20px", margin: "0 5px 0 10px" }}
                      onClick={handleAddMember}>
                      <img src={PlusIcon} />
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
          <small className="text-muted">Only people invited in this list can access</small>
          <div className="inviteteammember-column" style={{ marginTop: "20px" }}>
            {selectedMembers.map((x, index) => {
              return (
                <div className="inviteteammember-row" key={`inviteteammember_key_${index}`} style={{ alignItems: "center", marginBottom: "20px" }}>
                  <div className="inviteteammember-row inviteteammember-card">
                    <span> {x}</span>
                    <span onClick={() => removeItemFromList(index)} style={{ cursor: "pointer", color: "red" }}>
                      x
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="inviteteammember-row inviteteammember-button">
          <Button className="dark-btn" onClick={submit}>
            Invite Users
          </Button>

          {props.closeAddNewMembers && (
            <Button className="dark-btn" variant="light" onClick={handleCancel}>
              Cancel
            </Button>
          )}
        </div>
      </div>
    </div>
  );

  const closeContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: 40,
    height: 40,
    backgroundColor: "#F3F5F7",
    position: "absolute",
    marginTop: 20,
    marginRight: -510,
    borderRadius: 40,
  };

  return (
    <ModalComponent
      className="modal-container"
      data={content}
      styleCloseContainer={closeContainerStyle}
      modalIsOpen={props.showAddNewMembers}
      setModalIsOpen={props.setShowAddNewMembers}
      showCloseText={false}
    />
  );
}

export default InviteTeamMember;
